<template>
  <div class="ly1" style="position:relative" v-show="contentShow">
    <LeftList :keyMap="keyMap" :data="leftData" />
    <div class="ly1-right" style="margin-top:10px">
      <ChartLine :chartOption="chartOption" height="520px" :activeCode="activeIndex2Code"/>
    </div>
  </div>
</template>

<script>
import LeftList from "../../../../components/layout/leftList";
// import Rolling from "../../../../components/chart/rolling";
// import Compaction from "../../../../components/chart/compaction";
import ChartLine from "../../../../components/chart/line";
import {unique} from "../../../../utils/commons"
// import GridLayout from "../../../../components/layout/grid";
export default {
  data() {
    return {
      leftData: [],
      chartOption: {},
      keyMap: {
        paverEquipName: ["车辆名称", ""],
        maxSpeed: ["最高速度", "m/min"],
        minSpeed: ["最低速度", "m/min"],
        averageSpeed: ["平均速度", "m/min"],
      },
      contentShow: false
    };
  },
  computed: {
    // workId() {
    //   return this.$store.getters["quality/activeWorkId"];
    // },
  },
  created() {},
  mounted() {
    // this.getData();
  },
  props: {
    pavingQualitySpeed: {
      type: Object,
      default: function () {
        return {};
      },
    },
    activeIndex2Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
    // workId: {
    //   type: Number,
    //   default: function () {
    //     return 0;
    //   },
    // },
  },
  watch: {
    pavingQualitySpeed: function (newValue) {
      this.setData = newValue
      this.getData(this.setData);
      this.dataValue = newValue;
    },
    activeIndex2Code: {
      handler(newVal) {
        //console.log(newVal);
        // setTimeout(function(){
          if(newVal == 1){
            this.contentShow = true
          }else{
            this.contentShow = false
          }
        // },100)
        
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    getData(res) {
      //console.log(res)
      let getDataVal = res.dataList
      this.leftData = res.dataList;
      let resGet = []
      res.dataList.map(item=>{
        resGet=resGet.concat(Object.keys(item.pileSpeedMap))
      })
      resGet=unique(resGet).sort();
      let getxAxisList = resGet
      let xAxisList = resGet
      // let resGet = res.dataList[0].pileSpeedMap
      // const xAxisList = []
      // for(let key in resGet){
      //   xAxisList.push(key)
      // }
      // let getxAxisList = xAxisList
      
      //console.log("getxAxisList", getxAxisList);
      // const series = res.map((item, index) => {
      //   return {
      //     name: "摊铺车" + (index + 1),
      //     type: "line",
      //     symbol: "circle",
      //     symbolSize: 8,
      //     data: xAxisList.map((key) => {
      //       return item.pileSpeedMap[key] || 0;
      //     }),
      //   };
      // });
      let series = []
      for(let i=0;i<getDataVal.length;i++){
        let yData = []
        for(let j=0;j<getxAxisList.length;j++){
          yData.push(getDataVal[i].pileSpeedMap[getxAxisList[j]])
        }
        let setObj = {
          name: getDataVal[i].paverEquipName,
          type: 'line',
          data: yData
        }
        series.push(setObj)
      }
      //console.log(series)
      this.chartOption = Object.assign(
        {},
        {
          dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
          legend: {
            // data: legend,
          },
          grid: {
            bottom: 70,
            top: 30,
          },
          xAxis: [
            {
              type: "category",
              data: getxAxisList,
              splitArea: {
                show: true,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "m/min",
              splitArea: {
                show: true,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "5%",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        }
      );
    },
  },
  components: {
    LeftList,
    // Rolling,
    // Compaction,
    ChartLine,
    // GridLayout,
  },
};
</script>

<style lang="scss" scoped="">
</style>